import api from './api';
import { HEADERS } from 'src/constants/headers';
import { queryClient } from 'src/queryClient';

const getSessionCacheKey = (authorization = '') => {
    let hash = 0;

    for (let index = 0; index < authorization.length; index += 1) {
        hash = (hash * 31 + authorization.charCodeAt(index)) | 0;
    }

    return hash.toString(36);
};

export const fetchDashboardChart = (endpoint, values) => {
    const headers = HEADERS();
    const sessionCacheKey = getSessionCacheKey(
        headers.headers.Authorization
    );

    return queryClient.fetchQuery({
        queryKey: ['dashboard-chart', sessionCacheKey, endpoint, values],
        queryFn: () => api.post(endpoint, values, headers),
    });
};
